import { getDataAPI, postDataAPI } from "../../../services/apiWrapper";
import { errorAlert, successAlert } from "../../../utils/alert";

/*
 * Membership fee master, admin side. Four flat figures: Individual and Other
 * (organisation), each with a 1-year and a Lifetime price.
 */

const adminToken = () => localStorage.getItem("adminToken");

export const getMembershipFeeSetting = () => async (dispatch) => {
  try {
    const response = await dispatch(
      getDataAPI("admin/membership-fee/setting", adminToken())
    );
    return response.data.data || null;
  } catch (error) {
    return null;
  }
};

export const saveMembershipFeeSetting = (data) => async (dispatch) => {
  try {
    const response = await dispatch(
      postDataAPI("admin/membership-fee/setting", data, adminToken())
    );
    successAlert(response.data.message || "Membership fee saved.");
    return true;
  } catch (error) {
    errorAlert(error.response?.data?.message || "That could not be saved.");
    return false;
  }
};
